/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { paymentSchedulingControllerUpdatePaymentScheduling } from '../fn/payment-scheduling/payment-scheduling-controller-update-payment-scheduling';
import { PaymentSchedulingControllerUpdatePaymentScheduling$Params } from '../fn/payment-scheduling/payment-scheduling-controller-update-payment-scheduling';

@Injectable({ providedIn: 'root' })
export class PaymentSchedulingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `paymentSchedulingControllerUpdatePaymentScheduling()` */
  static readonly PaymentSchedulingControllerUpdatePaymentSchedulingPath = '/keus-payments/payment-scheduling/{tenant}/{visitId}';

  /**
   * Update payment scheduling for visit rescheduling.
   *
   * Updates the EventBridge schedule for a visit when the booking date changes. Used primarily for consultation rescheduling to avoid redirecting to Stripe when payment method is already saved.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentSchedulingControllerUpdatePaymentScheduling()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentSchedulingControllerUpdatePaymentScheduling$Response(params: PaymentSchedulingControllerUpdatePaymentScheduling$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return paymentSchedulingControllerUpdatePaymentScheduling(this.http, this.rootUrl, params, context);
  }

  /**
   * Update payment scheduling for visit rescheduling.
   *
   * Updates the EventBridge schedule for a visit when the booking date changes. Used primarily for consultation rescheduling to avoid redirecting to Stripe when payment method is already saved.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentSchedulingControllerUpdatePaymentScheduling$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentSchedulingControllerUpdatePaymentScheduling(params: PaymentSchedulingControllerUpdatePaymentScheduling$Params, context?: HttpContext): Observable<void> {
    return this.paymentSchedulingControllerUpdatePaymentScheduling$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
